export default "__VITE_ASSET__5e1502f4__"